import Features from '@/dealroadshow/ui/components/Landing/Features';
import LandingLayout from '@drs/ui/Landing/Layout/LandingLayout';
import useSetLanguage from '@framework/i18n/hooks/useSetLanguage';
import { LOCALES } from '@/dealroadshow/application/config/i18n';
import withApplicationProps from '@/dealroadshow/application/withApplicationProps';

export const getServerSideProps = withApplicationProps(() => ({ props: {} }));

export default () => {
  useSetLanguage(LOCALES.EN);

  return (
    <LandingLayout>
      <Features />
    </LandingLayout>
  );
};
